// extracted by mini-css-extract-plugin
export default {"btnpwd":"_76a7799bd8"};